const installPromptState = window.HITLInstallPrompt ||= { event: null }
const mobileMenuQuery = window.matchMedia("(max-width: 720px)")

window.addEventListener("beforeinstallprompt", (event) => {
  if (!mobileMenuQuery.matches) return
  if (!document.querySelector("[data-install-prompt-target~='button']")) return

  event.preventDefault()
  installPromptState.event = event
  window.dispatchEvent(new CustomEvent("hitl:beforeinstallprompt"))
})
